import { getCurrentUser } from './permissions';

/** Stable id for device-local prefs (language, font, theme) per signed-in desk user. */
export function getPreferenceScopeId(): string {
  const user = getCurrentUser();
  if (user?.id) return String(user.id);
  if (user?.email) return user.email.trim().toLowerCase();
  if (typeof localStorage !== 'undefined') {
    const email = localStorage.getItem('userEmail');
    if (email) return email.trim().toLowerCase();
  }
  return 'guest';
}

export function preferenceStorageKey(base: string): string {
  const scope = getPreferenceScopeId().replace(/[^a-zA-Z0-9@._-]/g, '_');
  return `${base}::${scope}`;
}

export function readScopedStorage(base: string): string | null {
  if (typeof localStorage === 'undefined') return null;
  const scoped = localStorage.getItem(preferenceStorageKey(base));
  if (scoped != null) return scoped;
  return localStorage.getItem(base);
}

export function writeScopedStorage(base: string, value: string): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(preferenceStorageKey(base), value);
}
